module.exports = __webpack_public_path__ + "img/cloudsync.9bdcc651.svg";